// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Controls_wrapper__ZqxvZ","btns":"Controls_btns__3hsif"};